module.exports = __webpack_public_path__ + "media/bootstrap-icons/heptagon-fill-7ef11069.svg";